import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.url = this.el.dataset.url;
        this.el.addEventListener('change', this.onChange.bind(this));
    }

    onChange(e) {
        this.fetchData();
    }

    fetchData() {
        this.el.classList.add('is-loading');
        // add class on html
        document.body.parentElement.classList.add('page-is-loading');
        if (this.controller) {
            this.controller.abort();
        }
        this.controller = new AbortController();
        fetch(this.url + '?' + new URLSearchParams(new FormData(this.el)), {
            signal: this.controller.signal
        })
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                document.getElementById('conferences-list').innerHTML = doc.getElementById('conferences-list').innerHTML;
                document.body.parentElement.classList.remove('page-is-loading');

                // check for #pagination remove it if absent, add it if present
                let pagination = doc.getElementById('pagination');
                let paginationContainer = document.getElementById('pagination');
                if (pagination) {
                    if (paginationContainer) {
                        paginationContainer.innerHTML = pagination.innerHTML;
                    } else {
                        document.getElementById('conferences-list').insertAdjacentElement('afterend', pagination);
                    }
                } else {
                    if (paginationContainer) {
                        paginationContainer.remove();
                    }
                }
                setTimeout(() => {
                    this.el.classList.remove('is-loading');
                }, 700);
            })
            .catch(err => {
                document.body.parentElement.classList.remove('page-is-loading');
                this.el.classList.remove('is-loading');
            });
    }
}
